// Core modules
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

// Rxjs modules
import { Observable } from 'rxjs';

// Constant
import { TOKEN_NAME } from '../auth.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the user token from local storage
    const token = localStorage.getItem(TOKEN_NAME);

    // If the token exists inject the token in the header
    if (token) {
      // Clone the existing request because you can't modify a request after creating it
      const cloned = req.clone({
        // Add the token header
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      // Return the cloned header instead of the original
      return next.handle(cloned);
    }

    // If there is not a token return the original request unmodified
    return next.handle(req);
  }
}
